import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Empty = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M45.3125 43.75H4.6875C4.2731 43.75 3.87567 43.5854 3.58265 43.2924C3.28962 42.9993 3.125 42.6019 3.125 42.1875V23.4375C3.125 23.0231 3.28962 22.6257 3.58265 22.3326C3.87567 22.0396 4.2731 21.875 4.6875 21.875H10.9375C11.3519 21.875 11.7493 22.0396 12.0424 22.3326C12.3354 22.6257 12.5 23.0231 12.5 23.4375V34.8594H37.5V23.4375C37.5 23.0231 37.6646 22.6257 37.9576 22.3326C38.2507 22.0396 38.6481 21.875 39.0625 21.875H45.3125C45.7269 21.875 46.1243 22.0396 46.4174 22.3326C46.7104 22.6257 46.875 23.0231 46.875 23.4375V42.1875C46.875 42.6019 46.7104 42.9993 46.4174 43.2924C46.1243 43.5854 45.7269 43.75 45.3125 43.75ZM6.25 40.625H43.75V25H40.625V36.4219C40.625 36.8363 40.4604 37.2337 40.1674 37.5267C39.8743 37.8198 39.4769 37.9844 39.0625 37.9844H10.9375C10.5231 37.9844 10.1257 37.8198 9.83265 37.5267C9.53962 37.2337 9.375 36.8363 9.375 36.4219V25H6.25V40.625ZM26.5625 10.9375V7.8125C26.5625 7.3981 26.3979 7.00067 26.1049 6.70765C25.8118 6.41462 25.4144 6.25 25 6.25C24.5856 6.25 24.1882 6.41462 23.8951 6.70765C23.6021 7.00067 23.4375 7.3981 23.4375 7.8125V10.9375C23.4375 11.3519 23.6021 11.7493 23.8951 12.0424C24.1882 12.3354 24.5856 12.5 25 12.5C25.4144 12.5 25.8118 12.3354 26.1049 12.0424C26.3979 11.7493 26.5625 11.3519 26.5625 10.9375ZM18.0156 15.625C18.2907 15.316 18.432 14.9106 18.4085 14.4976C18.3851 14.0846 18.1988 13.6978 17.8906 13.4219L15.625 11.3281C15.4711 11.1917 15.2918 11.0869 15.0974 11.0197C14.9031 10.9525 14.6973 10.9243 14.492 10.9366C14.0774 10.9615 13.6896 11.1501 13.4141 11.4609C13.1385 11.7717 12.9977 12.1793 13.0226 12.5939C13.0475 13.0085 13.2361 13.3963 13.5469 13.6719L15.875 15.75C16.1599 16.0012 16.5264 16.1401 16.9062 16.1406C17.1163 16.1337 17.3229 16.0845 17.5135 15.9959C17.7041 15.9073 17.8749 15.7811 18.0156 15.625ZM34.1875 15.75L36.5156 13.6719C36.8264 13.388 37.0117 12.9923 37.0308 12.5718C37.0498 12.1513 36.9011 11.7405 36.6172 11.4297C36.3333 11.1189 35.9376 10.9336 35.5171 10.9145C35.0966 10.8955 34.6858 11.0443 34.375 11.3281L32.1094 13.4219C31.8762 13.6338 31.7126 13.9112 31.64 14.2177C31.5673 14.5243 31.589 14.8456 31.7022 15.1396C31.8154 15.4336 32.0148 15.6865 32.2743 15.8651C32.5338 16.0438 32.8412 16.1398 33.1562 16.1406C33.536 16.1401 33.9026 16.0012 34.1875 15.75Z"
        fill={color}
      />
    </svg>
  )
}
